import { Component, Inject, OnInit, Optional } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { AccionesDialog } from '@models/base/identificadores.model';
import { RolService } from '@services/rol/rol.service';
import { SnackBarService } from '@services/snackBar/snack-bar-service.service';
import { NgxSpinnerModule, NgxSpinnerService } from 'ngx-spinner';
import { DialogDeleteRolComponent } from './dialog-delete-rol/dialog-delete-rol.component';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDividerModule } from '@angular/material/divider';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSliderModule } from '@angular/material/slider';
import { MatTableModule } from '@angular/material/table';

@Component({
    standalone: true,
    imports: [MatFormFieldModule, MatInputModule, ReactiveFormsModule, MatCardModule, MatIconModule, MatButtonModule, MatDividerModule, NgxSpinnerModule, MatTableModule, MatSliderModule, MatSlideToggleModule, CommonModule, MatMenuModule, MatDialogModule, MatDatepickerModule, MatExpansionModule],
  selector: 'app-eliminar-rol',
  templateUrl: './eliminar-rol.component.html',
  styleUrls: ['./eliminar-rol.component.css']
})
export class EliminarRolComponent implements OnInit {

  constructor(
    public dialogRef: MatDialogRef<DialogDeleteRolComponent>,
    private snackBar: SnackBarService,
    private spinner: NgxSpinnerService,
    private RolService: RolService,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any
  ) {
  }

  ngOnInit(): void {
  }

  doAction() {
    this.delete(this.data.id)
  }

  closeDialog() {
    this.dialogRef.close({ event: AccionesDialog.Cancelar });
  }

  delete(id: number) {
    this.spinner.show("spEliminarRoles")
    this.RolService.delete(id)
      .subscribe(
        data => {
          this.spinner.hide("spEliminarRoles")
          this.snackBar.showSuccess("Registro eliminado correctamente.", "Exito");
          this.dialogRef.close({ event: AccionesDialog.Eliminar });
        },
        error => {
          this.spinner.hide("spEliminarRoles")
          this.snackBar.showError(error, "Error");
        }
      )
  }
  trackByItems(index: number, item: any): any { return item; }
}
